import {AfterViewInit, Component, HostListener, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../../services/user-services/user.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {first, take} from 'rxjs/operators';
import {AuthenticationService} from '../../../../services/authentication.service';
import {ProcessSharedService} from '../../../../services/process-shared.service';
import {ProcessService} from '../../../../services/user-services/process.service';
//import {MetaService} from '../../../../services/meta.service';
import {SchoolService} from '../../../../services/school.service';
import {HelperService} from '../../../../services/helper.service';
import {PartnerApiService} from '../../../../services/partner-api.service';
import {DateReformatSharedService} from '../../../../services/date-reformat-shared.service';
import {CalendarComponent} from '../../../../shared/components/ux/calendar/calendar.component';
import {NgbDatepickerModule, NgbModal, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {TiktokService} from '../../../../services/tiktok.service';
import {
  AccommodationItemCardComponent
} from '../../../../shared/components/accommodation-specific/accommodation-item-card/accommodation-item-card.component';
import {AccommodationAlertsComponent} from '../components/accommodation-alerts/accommodation-alerts.component';
import {LfAdvantagesComponent} from '../../../../shared/components/lf-advantages/lf-advantages.component';
import {AccommodationPaymentDetailsComponent} from '../components/accommodation-payment-details/accommodation-payment-details.component';
import {ComponentPropertyComponent} from '../components/component-property/component-property.component';
import {ItemBadgesComponent} from '../../../../shared/components/item-badges/item-badges.component';
import {BtnFavoriteComponent} from '../../../../shared/components/ux/buttons/btn-favorite/btn-favorite.component';
import {IconComponent} from '../../../../shared/components/icons-svgs/icons-svgs.component';
import {PropertyPhComponent} from '../../../../shared/components/ux/preloader-placeholder/property-ph/property-ph.component';
import {DatePipe, DecimalPipe, DOCUMENT, NgClass, NgIf, NgTemplateOutlet} from '@angular/common';
import {GlobalConstantsComponent} from '../../../../shared/global-constants/global-constants.component';
import {ReportFormComponent} from '../../../../shared/components/forms/report-form/report-form.component';
import {PlatformService} from '../../../../services/platform-service.service';
import {Subscription} from 'rxjs';
import {LocalSettingsService} from 'src/app/services/local-settings.service';

@Component({
  selector: 'app-property-layout',
  templateUrl: './property-layout.component.html',
  styleUrls: ['./property-layout.component.scss'],
  standalone: true,
  imports: [NgTemplateOutlet, NgIf, PropertyPhComponent, IconComponent, BtnFavoriteComponent, ItemBadgesComponent, ComponentPropertyComponent, AccommodationPaymentDetailsComponent, NgClass, NgbDatepickerModule, CalendarComponent, LfAdvantagesComponent, AccommodationAlertsComponent, AccommodationItemCardComponent, TranslateModule, DatePipe, ReportFormComponent, NgbTooltipModule, DecimalPipe]
})
export class PropertyLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  // ID de la chambre
  public currentId: number | string;
  public searchCity: string = 'lille';
  public locale: string;
  public initialLocale: string;
  public selectedRoom: any;
  public favList = [];
  public isMobile: boolean = false;
  public currentUser: any;
  public school: any;
  public FaqItems: any;
  public minDate = {
    year: null,
    month: null,
    day: null,
  };
  public maxDate = {
    year: null,
    month: null,
    day: null,
  };
  public startingCities: any[] = [];
  public isCalendarOpen: boolean = false;
  //-- Calendar
  private startDate;
  private endDate;
  public rangeDate = {
    start: undefined,
    end: undefined
  };
  public startDateString;
  public endDateString;
  deleteStartDateI: boolean = false;
  deleteEndDateI: boolean = false;

  public firstMonthRent: number;
  private urlPrefix: string = '';
  public logged: boolean = false;
  public noDates: boolean = false;
  public isClicked: boolean = false;
  public isSummaryOpen: boolean = false;
  private process;
  border = 'start';
  showTopBarMobile = true;
  public onGoingBooking = null;
  public isMobileCalendarOpen = false;
  public showFixedButton = false;
  public mobileShowPayment: boolean = false;
  public alertFilters = {
    minPrice: null,
    maxPrice: null,
    minMeter: null,
    maxMeter: null,
    wc: null,
    bathrooms: null,
    tenants_gender: [],
    duration: [],
    type: [],
    tenants: [],
    empty_rooms: [],
  };
  public similarOffers = [];
  public viewerCount: number = 0;
  // check bots var
  public crawler_agents: string[] = GlobalConstantsComponent.crawlerAgents;
  public isCrawler: boolean = false;
  private _sub$ = [];
  private eventSubscription: Subscription;


  @ViewChild('CalendarComponent') private CalendarComponent: CalendarComponent;
  @ViewChild('calendarMenu') calendarMenu;
  @ViewChild('resaBox2') resaBox2;
  @ViewChild('paymentBox') paymentBox;
  currentLanguage: string;

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (this.isMobile && this.selectedRoom && this.selectedRoom['disponibility'] && (this.calendarMenu && !this.calendarMenu.nativeElement.contains(event.target)) && (this.resaBox2 && !this.resaBox2.nativeElement.contains(event.target))) {
      if (!event.target.classList.contains('btn-close-black') && !event.target.classList.contains('btn-close-calendar') && !this.isSummaryOpen) {
        this.closeCalendar();
      }
    }

  }

  constructor(
    private authenticationService: AuthenticationService,
    private dateFactory: DateReformatSharedService,
    private helperService: HelperService,
    private partnerService: PartnerApiService,
    private processService: ProcessService,
    private route: ActivatedRoute,
    private router: Router,
    private schoolService: SchoolService,
    private sharedProcessService: ProcessSharedService,
    private userService: UserService,
    private _translateService: TranslateService,
    private modalService: NgbModal,
    private tikTokService: TiktokService,
    private translate: TranslateService,
    private processSharedService: ProcessSharedService,
    private platformService: PlatformService,
    private _localSettings: LocalSettingsService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngOnInit(): void {

    this._localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );

    if (this.platformService.isBrowserPlatform()) {
      this.isMobile = this.userService.isMobileUser;
      this.currentId = this.route.snapshot.paramMap.get('id');
      this.locale = this._translateService.currentLang;
      this.initialLocale = this.locale;
      this.getCities();
      this._sub$.push(this.sharedProcessService.getRoom(this.currentId).pipe(first()).subscribe((data) => {
        this.setSelectedRoom(data);
      }));

      //-------- USER
      if (this.authenticationService.currentUserValue) {
        this.logged = true;
        this._sub$.push(this.sharedProcessService.getOnGoingBooking(this.currentId).pipe(first()).subscribe(data => {
          if (data) {
            this.onGoingBooking = data;
          }
        }));

        this.urlPrefix = '/';
        this.process = this.processService.getProcess('ACCOMMODATION');
        if (this.process) {
          this._sub$.push(this.sharedProcessService.updateProcessState('IN_PROGRESS', this.process).pipe(first()).subscribe());
        }
        this.currentUser = this.userService.getInfos();
        if(this.currentUser){
          let hubspotDatas = {
            campagne: '',
            source: '',
            medium: ''
          };

          hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
          this._sub$.push(this.userService.setHubspotDeal(3321704, 11561519, hubspotDatas).subscribe());

          if (this.currentUser.accommodationFavorites) {
            this.favList = this.currentUser.accommodationFavorites.split(',');
          }
        }



      } else {
        this.logged = false;
        this.currentUser = null;
        if (localStorage && localStorage['tempFavorites']) {
          this.favList = JSON.parse(localStorage['tempFavorites']);
        }
      }
      this.school = this.schoolService.getCurrent();
      this._sub$.push(this.tikTokService.sendPageView('URL propertie', this.router.url, this.currentUser ? this.currentUser.id : 0, 'property paris'));
      //this._sub$.push(this.metaService.sendPageView('ViewList ', this.router.url, this.currentUser ? this.currentUser.id : 0, 0, 'property').subscribe());

      // Viewer count si pas un bot
      const userAgent = window.navigator.userAgent;
      this.isCrawler = this.crawler_agents.some(crawlerAgent => userAgent.indexOf(crawlerAgent) !== -1);
      if (!this.isCrawler && this.currentId) {
        this._sub$.push(this.processService.sendViewerCount('property', parseInt(this.currentId), (this.currentUser && this.currentUser.id ? this.currentUser.id : sessionStorage.getItem('tt_sessionId')))
          .pipe(first())
          .subscribe(async (data: any) => {
            this.viewerCount = data.viewers;
          }));
      }
      this.route.queryParams.pipe(take(1)).subscribe(param => {
        if (param) {
          if (param['campaign']) {
            this._localSettings.setReferer(param['campaign']);
          }
          if (param['click_id']) {
            this._localSettings.setClickid(param['click_id']);
          }
        }
      });
    }

    this.eventSubscription = this.platformService.eventEmitter.subscribe(data => {
      this.locale = data;
      if(this.rangeDate){
        if(this.rangeDate.start){
          this.startDateString = this.rangeDate.start;
          let dateParts = this.startDateString.split('/');
          this.startDateString = this.changeDateFormat(dateParts, true);
        }
        if(this.rangeDate.end){
          this.endDateString = this.rangeDate.end;
          let dateParts = this.endDateString.split('/');
          this.endDateString = this.changeDateFormat(dateParts, true);
        }
      }
    });

  }

  ngAfterViewInit(): void {
    if (this.isMobile) {
      const page_listener = this.document.querySelector('.page_listener');
      let lastScrollTop = 0;

      // show top bar on mobile based on scroll direction
      page_listener.addEventListener('scroll', () => {
        const currentScrollTop = page_listener.scrollTop;
        this.showTopBarMobile = currentScrollTop < lastScrollTop || currentScrollTop <= 0;
        lastScrollTop = currentScrollTop;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }

    this._sub$.forEach(s => {
      if (s) {
        s.unsubscribe();
      }
    });
  }

  // @TODO : use process state instead of redirect
  goToNext() {
    if ((!this.rangeDate.start || !this.rangeDate.end) && (!this.isCalendarOpen)) {
      this.openCalendar();
    } else {
      if ((!this.rangeDate.start || !this.rangeDate.end) && this.isCalendarOpen) {
        this.isClicked = true;
      } else {
        if (this.isSummaryOpen) {
          const tmpstart = this.dateFactory.makeEngDateFormat(this.rangeDate.start);
          const tmpend = this.dateFactory.makeEngDateFormat(this.rangeDate.end);
          const STARTDATE = new Date(tmpstart);
          const ENDDATE = new Date(tmpend);
          this.processService.setTempBooking(STARTDATE, ENDDATE, this.selectedRoom.id, '', '');
          this._sub$.push(this.userService.update({city: this.searchCity}).subscribe());
          this.router.navigate([this.currentLanguage + '/accommodation/informations']);
        } else {
          if (this.selectedRoom) {
            this.isSummaryOpen = true;
            this.firstMonthRent = this.getFirstMonthRent();
          }
          if (this.isMobile) {
            this.isMobileCalendarOpen = true;
          }
        }
      }
    }
  }

  private getSimilarOffers(room): void {
    //---- SIMILAR OFFERS
    this._sub$.push(this.processSharedService.getSimilarOffers({
      latitude: room.property_address.latitude,
      longitude: room.property_address.longitude,
      property_id: room.id
    }).subscribe(
      (response: any) => {
        this.similarOffers = response;
      }
    ));
  }

  // GET INFOS OF PROPERTY
  private setSelectedRoom(room) {
    if (room.partner && room.partner.configuration) {
      const x = JSON.parse(room.partner.configuration);
      if (x.cities[room.property_address.city_group]) {
        room.minimal_stay_duration = x.cities[room.property_address.city_group];
      }
    }
    this._sub$.push(this.partnerService.getPartnerFaq(room.partner_kId).pipe(first()).subscribe(data => {
      this.FaqItems = data;
    }));


    if (room.disponibility) {
      const current = new Date();
      const isAvailableBeforeToday = this.dateFactory.checkDatesDiff(current, new Date(room.disponibility.replace(' ', 'T')));
      if (isAvailableBeforeToday <= 0) {
        room.disponibility = current;
        this.minDate = {
          year: current.getFullYear(),
          month: current.getMonth() + 1,
          day: current.getDate(),
        };
      } else {
        const tmpStartDate = new Date(room.disponibility.replace(' ', 'T'));
        this.minDate = {
          year: tmpStartDate.getFullYear(),
          month: tmpStartDate.getMonth() + 1,
          day: tmpStartDate.getDate(),
        };
      }
    } else {
      this.setAlertFilters(room);
    }

    if(room.end_disponibility){
      const tmpMaxDate = new Date(room.end_disponibility.replace(' ', 'T'));
      this.maxDate = {
        year: tmpMaxDate.getFullYear(),
        month: tmpMaxDate.getMonth() + 1,
        day: tmpMaxDate.getDate(),
      };
    }
    else{
      const current = new Date();
      this.maxDate = {
        year: current.getFullYear() + 50,
        month: current.getMonth() + 1,
        day: current.getDate(),
      };
    }

    // Fil d'ariane
    const elementPartnerType = room.partner_type.replace(/\d+/g, '').toUpperCase().trim();
    if (elementPartnerType === 'CH' || elementPartnerType === 'ROOM_SHARED') {
      room.partner_type = 'room';
    }

    let city = this.startingCities.find(element => element.name.toLowerCase() == room.property_address.city.toLowerCase());
    if (!city && localStorage.getItem('city')) {
      city = this.startingCities.find(element => element.name.toLowerCase() == localStorage.getItem('city').toLowerCase());
    }
    this.searchCity = city?.name;
    this.selectedRoom = room;
    this.getSimilarOffers(this.selectedRoom);

  }

  private setAlertFilters(room): void {
    const priceRange = 50;
    const meterRange = 5;
    this.alertFilters.minPrice = room.price - priceRange;
    this.alertFilters.maxPrice = room.price + priceRange;
    this.alertFilters.minMeter = room.meter - meterRange;
    this.alertFilters.maxMeter = room.meter + meterRange;
    this.alertFilters.bathrooms = room.bathrooms_private;
    this.alertFilters.wc = room.wc_private;
    this.alertFilters.tenants.push(room.tenants);
    this.alertFilters.type.push(room.partner_type);
  }


  public returnUrl(element) {
    const url = window.location.protocol + '//' + window.location.host;
    switch (element) {
      case 'home': {
        return url +'/'+this.currentLanguage+ '/discover';
      }
      case 'list': {
        return url + '/'+this.currentLanguage+'/accommodation/list';
      }
      case 'city' : {
        return url +'/'+this.currentLanguage+ '/accommodation/list/' + (this.searchCity ? this.helperService.slugify(this.searchCity) : this.selectedRoom.property_address.city);
      }
      case 'type' : {
        return url +'/'+this.currentLanguage+ '/accommodation/list/' + (this.searchCity ? this.helperService.slugify(this.searchCity) : this.selectedRoom.property_address.city) + '?type=' + this.selectedRoom['partner_type'];
      }
    }
  }

  public share() {
    let text = '';
    if (this.translate.currentLang !== 'fr') {
      text = this.selectedRoom.property_description.summary;
    } else {
      text = this.selectedRoom.property_description.summary_fr;
    }
    const title = this.selectedRoom.name;
    const url = window.location.protocol + '//' + window.location.host + '/accommodation/property/' + this.selectedRoom.id;
    this.helperService.share(title, text, url);
  }


  public goBack() {
    if (this.searchCity) {
      this.router.navigate([this.urlPrefix + this.currentLanguage +  '/accommodation/list/' + this.helperService.slugify(this.searchCity)]);
    } else {
      this.router.navigate([this.urlPrefix + this.currentLanguage +  '/accommodation/list/']);
    }
  }


  public transformToMonth(days) {
    return Math.round(days / 30);
  }


  showCalendar() {
    this.isCalendarOpen = !this.isCalendarOpen;
  }

  checkBookingDate(d) {
    return this.rangeDate = d;
  }

  getStartDate(d) {
    this.noDates = false;
    this.isClicked = false;
    this.rangeDate.start = d.startdate;
    this.startDateString = this.rangeDate.start;
    this.rangeDate.end = this.endDate = this.endDateString = null;
    this.deleteStartDateI = false;
    this.border = 'end';
    if (d.startdate !== undefined) {
      let de = this.selectedRoom && this.selectedRoom.minimal_stay_duration ? this.selectedRoom.minimal_stay_duration : 3;
      if (de > 12) {
        de = this.transformToMonth(de);
      }
      this.CalendarComponent.addMonthsToDate(de);
    }
    return this.startDate = d.startdate;
  }

  getEndDate(d) {
    this.isCalendarOpen = !this.isCalendarOpen;
    this.isSummaryOpen = true;
    this.endDateString =  d.enddate;
    this.firstMonthRent = this.getFirstMonthRent();
    this.border = 'start';
    this.deleteEndDateI = false;
    return this.endDate = d.enddate;
  }

  // ------------- Calendar functions

  openCalendar() {
    this.isCalendarOpen = true;
    if (this.isMobile) {
      this.isMobileCalendarOpen = true;
    } else {
      this.CalendarComponent.hideput.toggle();
    }
  }

  private getCities(): void {
    this._sub$.push(this.schoolService.getStartingElements().pipe(first()).subscribe((data) => {
      this.startingCities = data.cities;
    }));
  }

  private getFirstMonthRent(): number {
    let dateParts = this.startDate.split('/');
    let language = this.translate.currentLang;
    let start;
    if(language === 'fr'){
       start = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    }
    else{
      start = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);
    }
    const end = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();

    return (this.selectedRoom.property_price.price / end) * (end - start.getDate() + 1);
  }


  deleteStartDate() {
    this.startDate = null;
    this.border = 'start';
    this.rangeDate.start = null;
    this.deleteStartDateI = true;
    this.isSummaryOpen = false;
  }

  deleteEndDate() {
    this.endDate = null;
    if (this.rangeDate.start) {
      this.border = 'end';
    }
    this.rangeDate.end = null;
    this.deleteEndDateI = true;
    this.isSummaryOpen = false;
  }

  // mobile calendar
  openCalendarMobile() {
    this.isSummaryOpen = false;
  }

  getBoolean(value) {
    switch (value) {
      case true:
      case 'true':
      case 1:
      case '1':
      case 'on':
      case 'yes':
        return true;
      default:
        return false;
    }
  }

  public openModal(content) {
    this.isCalendarOpen = true;
    if (this.isMobile) {
      this.isMobileCalendarOpen = true;
    }
    this.modalService.open(content, {size: 'xl', centered: true, backdropClass: 'opacity-1'});
  }

  public closeCalendar() {
    this.isCalendarOpen = false;
    if (this.isMobile) {
      this.isMobileCalendarOpen = false;
      this.showFixedButton = false;
    } else {
      this.CalendarComponent.hideput.close();
    }
  }

  public goToProfile(): void {
    this.router.navigate(['/account/my-profile'], {queryParams: {tab: 'purchase'}});
  }

  public changeDateFormat(dateParts, toString){
    let dateFormatted;
    if(this.locale === 'fr'){
      if(toString === true){
        if(this.initialLocale === 'fr'){
          dateFormatted = dateParts[0] + '/' + dateParts[1] + '/' + dateParts[2];
        }
        else{
          dateFormatted = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
        }
      }
      else {
        dateFormatted = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      }
    }
    else{
      if(toString === true){
        if(this.initialLocale === 'fr'){
          dateFormatted = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
        }
        else {
          dateFormatted = dateParts[0] + '/' + dateParts[1] + '/' + dateParts[2];
        }
      }
      else {
        dateFormatted = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);

      }
    }
    return dateFormatted;
  }


}
